<!-- 合同延期记录 -->
<template>
  <tablePageComp
    :columnsList="columnsList"
    :dataList="dataList"
    :orderNumConfig="{}"
    :getDataConfig="dataQueryFunc()"
    :updateDataSignObj="{
      updateDataTag,
    }"
    :totalCount="totalCount"
  >
  </tablePageComp>
</template>

<script>
export default {
  props: ["contractProp"],
  data() {
    return {
      dataList: [],
      columnsList: [
        {
          label: "合同编号",
          prop: "customer_id",
          width: 150,
        },
        {
          label: "合同到期时间",
          prop: "due_time",
          formatter: (val) => val.split(" ")[0],
        },
        {
          label: "延期天数",
          prop: "deferred_days",
        },
        {
          label: "延期日期",
          prop: "deferred_time",
        },
        {
          label: "申请人",
          prop: "applicant",
          formatter: (val) => this.$tools.conversionName(val),
        },
        {
          label: "审核人",
          prop: "verifier",
          formatter: (val) => this.$tools.conversionName(val),
        },
        {
          label: "审核时间",
          prop: "update_time",
        },
        {
          label: "申请时间",
          prop: "create_time",
        },
      ],
      totalCount: 0,
      updateDataTag: false,
    };
  },
  methods: {
    dataQueryFunc() {
      let paramObj = {
        customer_id: this.contractProp.customer_id,
        is_check: "1", // 审核通过
      };

      return {
        apiName: "getDeferredApplyFuc",
        paramObj,
        success: function(response, callback) {
          // console.log(response);
          this.dataList = response.data.data.list;
          this.totalCount = response.data.data.count;
          if (callback) {
            callback();
          }
        }.bind(this),
        failed: function(error, callback) {
          console.log(error);
          if (callback) callback();
        },
      };
    },
  },
};
</script>

<style></style>
